export default __webpack_public_path__ + "static/media/blondie.98dfdf04.jpeg";